import { ChangeDetectionStrategy, Component, computed, inject, input, LOCALE_ID, output } from '@angular/core';
import { ViewDetails } from '../../../../../shared/ui/view-details/view-details';
import { ProductConfigVTO } from '../../../../../pages/admin-dashboard/products/product.model';
import { InfoField } from '../../../../../shared/ui/view-details/view-details.model';

@Component({
  selector: 'app-product-config-view',
  standalone: true,
  imports: [ViewDetails],
  templateUrl: './product-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductConfigView {
  config = input.required<ProductConfigVTO>();
  editRequested = output<void>();

  private locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));

  fields = computed<InfoField[]>(() => {
    const c = this.config();
    const ar = this.isArabic();
    const list: InfoField[] = [];

    if (c.orderLimitQuantity != null) {
      list.push({
        label: ar ? 'حد الطلب للصنف' : 'Product Order Limit',
        value: c.orderLimitQuantity,
        unit: ar ? 'وحدة' : 'Units',
      });
    }

    if (c.orderLimitDays != null) {
      list.push({
        label: ar ? 'فترة الحد' : 'Order Limit Period',
        value: c.orderLimitDays,
        unit: ar ? 'يوم' : 'Days',
      });
    }

    if (c.orderLimitTotalCash != null) {
      list.push({
        label: ar ? 'ربط على قيمة الفاتورة' : 'Linked to Invoice Value',
        value: c.orderLimitTotalCash.toFixed(2),
        unit: ar ? 'ج.م' : 'EGP',
      });
    }

    return list;
  });
}
